import React, { Component } from "react";
import ReportGeneralTable from "../report/ReportGeneralTable";
import ReportStore from "../../stores/ReportStore";
import FontAwesome from "react-fontawesome";
import { Popover, OverlayTrigger } from "react-bootstrap";
import StockNewMixPaintDoc from "./StockNewMixPaintDoc";
import { connect } from "react-redux";

class StockMixPaintReport extends Component {
  constructor(...args) {
    super(...args);
    this.state = { showTable: true, mpNo: "", doc: "" };
    this.qoTable = null;
  }

  // renameDoc(newPoNo){
  //   this.refs.soDoc.renameDoc(newPoNo)
  // }

  componentWillReceiveProps(newProps) {
    if (newProps.show && newProps.show !== this.props.show) {
      //this.loadData()
    }
  }

  showTable() {
    this.setState({ showTable: true });
    if (this.qoTable !== null) this.qoTable.refreshTable();
    if (this.props.onTableShow !== undefined) {
      this.props.onTableShow();
    }
  }

  onRowSelect(item) {
    this.setState({ showTable: false, mpNo: item.doc_no, doc: item });
  }

  onDocNew() {
    this.setState({ showTable: false, doc: { doc_no: "" } });
  }

  onDocClose() {
    this.showTable();
  }

  loadData(
    year,
    month,
    day,
    searchBy,
    query,
    activePage,
    itemPerPage,
    callback
  ) {
    ReportStore.loadMixPaintList(
      year,
      month,
      day,
      searchBy,
      query,
      activePage * itemPerPage,
      itemPerPage,
      callback
    );
  }

  loadDataRange(
    start,
    end,
    searchBy,
    query,
    activePage,
    itemPerPage,
    callback
  ) {
    ReportStore.loadMixPaintListRange(
      start,
      end,
      searchBy,
      query,
      activePage * itemPerPage,
      itemPerPage,
      callback
    );
  }

  // renderStatus(status,row){
  //   status = status*1
  //   let result  = (<span></span>)
  //   if(status===1){
  //     result =  (<span className='label label-success'>ชำระเงินแล้ว</span>)
  //   }else    if(status===2){
  //     result =  (<span className='label label-primary'>ขายเครดิต</span>)
  //   }else{
  //     result = (<span></span>)
  //   }
  //   if(row.recordid!==undefined && row.recordid*1>0){
  //     result = (<div>{result} {this.renderStockStatus(row.recordid)}</div>)
  //   }
  //   return result
  // }

  renderStatus(status, row) {
    let result = <span></span>;
    let { messages } = this.props;
    if (row.work_status == 0) {
      result = (
        <span className="label label-default" data-value="0">
          {messages["Start"]}
        </span>
      );
    } else if (row.work_status == 1) {
      result = (
        <span className="label label-warning" data-value="1">
          {messages["Under Repair"]}
        </span>
      );
    } else if (row.work_status == 2) {
      result = (
        <span className="label label-primary" data-value="2">
          {messages["Wait For Car"]}
        </span>
      );
    } else if (row.work_status == 3) {
      result = (
        <span className="label label-success" data-value="3">
          {messages["Work Done"]}
        </span>
      );
    } else {
      result = <span></span>;
    }

    return result;
  }

  // renderStockStatus(status){
  //   status = status*1
  //   if(status>0){
  //     return (<span className='label label-default'>ตัดสต๊อกแล้ว</span>)
  //   }else{
  //     return (<span></span>)
  //   }

  // }

  onIconClick(workNo, e) {
    //alert("Click!")
    if (process.env.NODE_ENV === "development") {
      alert("show_work_doc:" + workNo);
    } else {
      window.show_work_doc(workNo);
    }
  }

  onRenderColumn(data, col, row) {
    let { messages } = this.props;
    if (col === 9) {
      return this.renderStatus(data, row);
    } else if (col === 2) {
      if (data != "") {
        let title = messages["Work No"] + " " + data;
        let popoverHoverFocus = (
          <Popover id="popover-trigger-hover-focus" title={title}>
            <strong>{messages["Click Icon To View Worksheet"]}</strong>
          </Popover>
        );

        return (
          <span>
            {data}{" "}
            <OverlayTrigger
              trigger={["hover", "focus"]}
              placement="right"
              overlay={popoverHoverFocus}
            >
              <FontAwesome
                onClick={this.onIconClick.bind(this, data)}
                className="text-blue"
                name="file-text-o"
              />
            </OverlayTrigger>
          </span>
        );
      }
    } else {
      return <span>{data}</span>;
    }
  }

  render() {
    let { doc, showTable } = this.state;
    let { messages } = this.props;
    const headerTitles = [
      { title: messages["Borrowing Date"], width: "150px" },
      { title: messages["Doc No"], width: "100px" },
      { title: messages["Work No"], width: "150px" },
      { title: messages["Car Registration"], width: "150px" },
      { title: messages["Brand"], width: "150px" },
      { title: messages["Model"], width: "150px" },
      { title: messages["Technician"], width: "150px" },
      { title: messages["Requester"], width: "150px" },
      { title: messages["Color Code"], width: "150px" },
      { title: messages["description"], width: "150px" },
    ];
    const searchOptions = [
      {
        label: messages["Car Registration"],
        value: "car_registration_no",
      },
      {
        label: messages["Requester"],
        value: "request_by",
      },
      {
        label: messages["Work No"],
        value: "work_no",
      },
    ];
    return (
      <div>
        <div style={{ display: showTable ? "block" : "none" }}>
          <ReportGeneralTable
            ref="qoTable"
            onRef={(ref) => {
              this.qoTable = ref;
            }}
            title={messages["Picking Primary Color Mixed"]}
            txtTable={false}
            newTitle={messages["Add Picking up Item"]}
            show={this.props.show}
            loadOnShow={true}
            showNewButton={true}
            showPrintButton={false}
            headerTitles={headerTitles}
            bodyColumn={[
              "doc_date",
              "doc_no",
              "work_no",
              "car_registration_no",
              "brand",
              "model",
              "mixed_by",
              "request_by",
              "colorcode",
              "description",
            ]}
            excludeColumn={[
              "status_html",
              "doc_no",
              "response_by",
              "description",
              "start_mix_date",
              "end_mix_date",
              "request_mix_date",
            ]}
            excludeClickColumn={["work_no"]}
            searchOptions={searchOptions}
            searchBy={"car_registration_no"}
            loadData={this.loadData.bind(this)}
            loadDataRange={this.loadDataRange.bind(this)}
            onRenderColumn={this.onRenderColumn.bind(this)}
            onRowSelect={this.onRowSelect.bind(this)}
            onDocNew={this.onDocNew.bind(this)}
            docType={"quotation"}
          />
        </div>
        <div>
          <StockNewMixPaintDoc
            show={!showTable}
            doc={doc}
            onClose={this.onDocClose.bind(this)}
          />
        </div>
      </div>
    );
  }
}

StockMixPaintReport.defaultProps = {
  show: false,
};
export default connect(
  (state) => ({ messages: state.message.view.stock.StockMixPaintReport }),
  null,
  null,
  { withRef: true }
)(StockMixPaintReport);



// WEBPACK FOOTER //
// ./src/view/stock/StockMixPaintReport.js